import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const pinListingImageFn = httpsCallable(functions, "pinListingImage");

// file: File object from input; returns { cid, ipfsUri, gatewayUrl, sha256 }
export async function pinListingImage(listingId, file) {
  if (!listingId || typeof listingId !== "string") {
    throw new Error("listingId must be a non-empty string");
  }
  if (!(file instanceof File)) {
    throw new Error("file must be a File instance");
  }
  const base64 = await fileToBase64Raw(file);
  const { data } = await pinListingImageFn({
    listingId,
    base64,
    fileName: file.name,
  });
  return data;
}

async function fileToBase64Raw(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result; // data:*/*;base64,....
      const commaIndex = result.indexOf(",");
      if (commaIndex === -1) {
        return reject(new Error("Invalid DataURL format"));
      }
      resolve(result.slice(commaIndex + 1));
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
